import { observer } from 'mobx-react';
import React from 'react';

import { DbKey } from '../../../../adl-gen/common/db';
import { UserGroup } from '../../../../adl-gen/totalinteraction/futurefit/db';
import { UserGroupListEntry } from '../../../../adl-gen/totalinteraction/futurefit/frontend';
import { GroupData } from '../../../../adl-gen/totalinteraction/futurefit/requests';
import { Loader } from '../../../../loader/loader';
import { UserGroupStore } from '../../../stores';
import { FormMode } from '../../common/form';
import { AdminPageLayoutFn } from '../../common/page-layout/admin-page-layout';
import { UserGroupForm } from '../../components/forms/usergroup-form/usergroup-form';
import { GroupDetailsView } from '../../components/detail-views/group-details-view';

interface UserGroupDetailsScreenProps {
  pageLayout: AdminPageLayoutFn;
  mode?: FormMode;

  store: UserGroupStore;

  onCancel?(): Promise<void>;
  onUpdate?(userGroupId: DbKey<UserGroup>): Promise<void>;
}

@observer
export class UserGroupDetailsScreen extends React.Component<UserGroupDetailsScreenProps> {
  renderDetails = observer((group: UserGroupListEntry) => {
    const { onUpdate, store } = this.props;

    const data = store.loadingData;

    /// TODO: This is not great - assuming there's only one item in an array
    /// rather than just selecting that one item
    if (data.kind === 'value' && onUpdate) {
      return (
        <GroupDetailsView
          item={group}
          data={data.value}
          onUpdate={onUpdate}
          role={store.isSuperUser ? 'super' : 'client-admin'}
        />
      );
    } else {
      return null;
    }
  });

  renderCreateForm = observer((groupData: GroupData) => {
    const { mode, onCancel, store } = this.props;

    if (onCancel) {
      return (
        <UserGroupForm
          data={groupData}
          store={store}
          mode={mode}
          onCancel={onCancel}
          // TODO: remove this
          isOpen={true}
        />
      );
    } else {
      return null;
    }
  });

  renderUpdateForm = observer((group: UserGroupListEntry) => {
    const { mode, onCancel, store } = this.props;

    const groupData = store.loadingData.kind === 'value' ? store.loadingData.value : undefined;
    if (onCancel && groupData) {
      return (
        <UserGroupForm
          item={group}
          data={groupData}
          store={store}
          mode={mode}
          onCancel={onCancel}
          // TODO: remove this
          isOpen={true}
        />
      );
    } else {
      return null;
    }
  });

  DetailsLoader = () => {
    const { store, mode } = this.props;
    const group = store.selectedGroup;
    if (group) {
      if (mode === 'update' || mode === 'delete') {
        return (
          <Loader
            state={group}
            // state={store.loadingData}
            LoadedComponent={this.renderUpdateForm}
          />
        );
      } else {
        /// View
        return <Loader state={group} LoadedComponent={this.renderDetails} />;
      }
    } else {
      /// Create - mode doesn't matter
      return <Loader state={store.loadingData} LoadedComponent={this.renderCreateForm} />;
    }
  };

  render() {
    /// Title is required to ensure subnav gets rendered
    return (
      <this.props.pageLayout title={'Administration - Group'}>
        <this.DetailsLoader />
      </this.props.pageLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/ui/screens/usergroup-detail-screen/usergroup-detail-screen.tsx